import * as Sentry from '@sentry/react';
import { getLocale, getStoredLocale, setBundle } from '@/core/utils/translation';
import { loadDayjsLocale } from '@/core/config/dayjs';

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [],
    environment: import.meta.env.VITE_ENVIRONMENT,
  });
}

const boot = async () => {
  const locale = getStoredLocale();

  try {
    const response = await fetch(`${import.meta.env.VITE_API_URL}/translations/${locale}`);
    const body = await response.json();
    if (body?.data?.translations) {
      setBundle(body.data.locale ?? locale, body.data.translations);
    }
  } catch {
    // Falls through to the baked-in et.json snapshot in translation.ts.
  }

  await loadDayjsLocale(getLocale());
  await import('./bootstrap');
};

boot();
